
    import {useStore} from "@/store";
    import common from "@/util/common";
    import reportMsgUt from "@/util/reportMsg";
    import DetectPlayer from '@/views/components/ALvideoPlayer/index.vue';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive, toRefs} from "vue";
    import {getVideoPlayAuth} from '@/service'
    interface State {
        playAuth: string;
        loopVideo: any;
        videoId: string;
        playData: any;
        reportMsg: object;
        videoInfo: object[];
        currentVideoIndex: number;
    }

    export default defineComponent({
        name: "LoopCarVideoH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                playAuth: '',
                loopVideo: {},
                videoId: '',
                playData: null,
                reportMsg: {},
                videoInfo: [],
                currentVideoIndex: 0,
            })
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {templateCode} = query;
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            
            state.reportMsg = reportMsgUt;
            const getPlayAuth = function (videoId) {
                videoId && getVideoPlayAuth({videoId}).then((res: any) => {
                    state.playAuth = res;
                    state.playData = {
                        playAuth: res,
                        vodId: state.videoId,
                        cover: state.loopVideo && state.loopVideo.videoFirstImg,
                        autoplay: false,
                        size: state.loopVideo && state.loopVideo.videoSize
                    }
                });
            };
            const VIDEO_CODE_MAP = {
                SV9: 'Экстерьер/Интерьер',
                SV7: 'ЛКП',
                SV10: 'Ходовая',
                SV11: 'Двигатель/КПП'
            };
            const VIDEO_CODE_ORDER = ['SV9', 'SV7', 'SV11', 'SV10'];

            watch(reportData, (data: any) => {
                const {videoInfo} = data
                if (videoInfo && videoInfo.length) {
                    const filtered = VIDEO_CODE_ORDER
                        .map(code => videoInfo.find(v => v.videoCode === code))
                        .filter(Boolean)
                        .map(v => ({ ...v, videoName: VIDEO_CODE_MAP[v.videoCode] }));
                    state.loopVideo = filtered[0];
                    state.videoId = state.loopVideo && state.loopVideo.videoId;
                    getPlayAuth(state.videoId);
                    state.videoInfo = filtered;
                }
            }, {immediate: true, deep: true})

            function switchTab(index) {
                state.currentVideoIndex = index;
                state.loopVideo = state.videoInfo[index];
                state.videoId = state.loopVideo && state.loopVideo.videoId;
                getPlayAuth(state.videoId);
            }

            return {
                state,
                router,
                store,
                getPlayAuth,
                switchTab
            }
        },
        components: {
            DetectPlayer
        }
    })
